import { gql } from '@apollo/client';

export const GET_MATCHING_CANDIDATES = gql`
  query GetMatchingCandidates($roleId: String!, $programIds: [String!]) {
    vm {
      matchingCandidates(roleId: $roleId, programIds: $programIds) {
        applicationId
        name
        email
        status
        dateSubmitted
        profile {
          profileId
          preferredName
          lastName
          dateOfBirth
          programs {
            programId
            name
          }
          simpleAvailability {
            simpleAvailabilityId
            mondayAm
            mondayPm
            tuesdayAm
            tuesdayPm
            wednesdayAm
            wednesdayPm
            thursdayAm
            thursdayPm
            fridayAm
            fridayPm
            saturdayAm
            saturdayPm
            sundayAm
            sundayPm
          }
        }
        applicationRoles {
          applicationRoleId
          role {
            activityRoleId
            name
          }
          status
        }
        funnel {
          name
        }
      }
    }
  }
`;

export const GET_APPLICANT_AVAILABILITY = gql`
  query GetApplicantAvailability($profileId: String!) {
    vm {
      profile(profileId: $profileId) {
        programs {
          programId
          name
        }
        simpleAvailability {
          simpleAvailabilityId
          mondayAm
          mondayPm
          tuesdayAm
          tuesdayPm
          wednesdayAm
          wednesdayPm
          thursdayAm
          thursdayPm
          fridayAm
          fridayPm
          saturdayAm
          saturdayPm
          sundayAm
          sundayPm
        }
      }
    }
  }
`;
